$('.case-studies-slider').slick({
    dots: false,
    infinite: true,
    arrows: false,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    slidesToShow: 1,
    pauseOnHover: true,
    slide: '.case-studies-slider > div',
});

$('.funding-slider').slick({
    dots: false,
    infinite: true,
    arrows: false,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    slidesToShow: 1,
    pauseOnHover: true,
    slide: '.funding-slider > div',
});

$('.accreditations-slider').slick({
    dots: false,
    infinite: true,
    arrows: false,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 6,
    slide: '.accreditations-slider > div',
    responsive: [
        {
            breakpoint: 1000,
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
            },
        }
    ]
});

if ($('.yt-player').length) {
    Plyr.setup('.yt-player', {
        controls: [
            'play-large',
            'play',
            'progress',
            'mute',
            'volume',
            'fullscreen',
        ],
        youtube: {
            rel: 0,
            showinfo: 0,
            iv_load_policy: 3,
            modestbranding: 1,
        },
    })
};
